
import React from 'react';
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { MessageCircle, Linkedin } from 'lucide-react';

interface CustomMessagesSectionProps {
  messages: {
    [key: string]: string;
  };
  onMessageChange: (platform: string, message: string) => void;
}

export const CustomMessagesSection: React.FC<CustomMessagesSectionProps> = ({
  messages,
  onMessageChange
}) => {
  return (
    <div className="space-y-4">
      <Label className="block text-base font-medium">Custom Share Messages</Label>
      {Object.entries(messages).map(([platform, message]) => (
        <div key={platform} className="space-y-2">
          <div className="flex items-center">
            {platform === 'whatsapp' && <MessageCircle className="h-4 w-4 mr-2" />}
            {platform === 'linkedin' && <Linkedin className="h-4 w-4 mr-2" />}
            <Label className="text-sm">{platform.charAt(0).toUpperCase() + platform.slice(1)} Message</Label>
          </div>
          <Textarea
            value={message}
            onChange={(e) => onMessageChange(platform, e.target.value)}
            placeholder={`Custom message for ${platform}`}
          />
        </div>
      ))}
    </div>
  );
};
